let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fotOn")).then(() => parcelRequire('iTIGl'));